import { useMemo } from "react";

// material-ui
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";

// project-imports
import AppBarStyled from "./AppBarStyled";
import HeaderContent from "./HeaderContent";
import IconButton from "components/@extended/IconButton";
import useConfig from "hooks/useConfig";
import { handlerDrawerOpen, useGetMenuMaster } from "api/menu";
import { DRAWER_SLOT_WIDTH, MINI_DRAWER_SLOT_WIDTH } from "config";
import { headerAppBarSx, headerIconButtonSx, V2 } from "./headerV2Tokens";
import "./headerV2.css";

// assets
import { PanelLeftOpen } from "lucide-react";

// ==============================|| MAIN LAYOUT - HEADER ||============================== //

export default function Header() {
  const theme = useTheme();

  const downLG = useMediaQuery(theme.breakpoints.down("lg"));
  useConfig();
  const { menuMaster } = useGetMenuMaster();
  const drawerOpen = menuMaster.isDashboardDrawerOpened;

  const headerContent = useMemo(() => <HeaderContent />, []);

  const mainHeader = (
    <Toolbar
      className="header-v2"
      sx={{
        px: { xs: 2, sm: 3, lg: 3 },
        minHeight: { xs: 64, sm: 68 },
        gap: { xs: 1, sm: 1.5 },
      }}
    >
      {/* Mobile only — temporary drawer has no visible chrome when closed */}
      {downLG && (
        <IconButton
          aria-label="Ouvrir le menu"
          onClick={() => handlerDrawerOpen(true)}
          edge="start"
          color="secondary"
          variant="text"
          size="large"
          sx={{
            ...headerIconButtonSx(false),
            ml: { xs: 0, lg: -0.5 },
          }}
        >
          <PanelLeftOpen size={22} color={V2.ink} strokeWidth={2} />
        </IconButton>
      )}

      {headerContent}
    </Toolbar>
  );

  const appBar = {
    position: "fixed",
    elevation: 0,
    sx: {
      ...headerAppBarSx,
      width: {
        xs: "100%",
        lg: drawerOpen
          ? `calc(100% - ${DRAWER_SLOT_WIDTH}px)`
          : `calc(100% - ${MINI_DRAWER_SLOT_WIDTH}px)`,
      },
    },
  };

  return (
    <>
      {!downLG ? (
        <AppBarStyled open={drawerOpen} {...appBar}>
          {mainHeader}
        </AppBarStyled>
      ) : (
        <AppBar {...appBar}>{mainHeader}</AppBar>
      )}
    </>
  );
}
